
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    title: { type: String, required: true },
    shortDescription: { type: String, required: false, default: undefined },
    tags: { type: Array, required: false, default: () => [] },
    image: { type: Object, required: false, default: undefined },
    url: { type: String, required: true },
    author: { type: Object, required: false, default: undefined },
    inSlider: { type: Boolean, required: false, default: false },
  },
})
